import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Logo } from './Logo';
const FOOTER_LINKS = [{
  label: 'Privacy Policy',
  href: '/privacy'
}, {
  label: 'Terms',
  href: '/terms'
}, {
  label: 'Website Disclaimer',
  href: '/disclaimer'
}, {
  label: 'Accessibility',
  href: '/accessibility'
}, {
  label: 'Contact',
  href: '/contact'
}, {
  label: 'Sitemap',
  href: '/sitemap'
}];
const SERVICE_LINKS = [{
  label: 'Buying property',
  href: '/buying-property'
}, {
  label: 'Selling property',
  href: '/selling-property'
}, {
  label: 'Contract review',
  href: '/contract-review'
}, {
  label: 'SMSF & trusts',
  href: '/smsf-trust-property'
}, {
  label: 'Commercial property',
  href: '/commercial-property'
}, {
  label: 'Property transfers',
  href: '/property-transfers'
}];
export function Footer() {
  return <footer className="bg-ink text-cream pt-20 pb-28 md:pb-12" data-id="element-428">
      <div className="max-w-7xl mx-auto px-5 md:px-6" data-id="element-429">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-8 mb-16" data-id="element-430">
          <div className="md:col-span-5 lg:col-span-4 space-y-6" data-id="element-431">
            <Logo inverted size="lg" data-id="element-432" />
            <p className="text-cream/65 leading-relaxed max-w-sm" data-id="element-433">
              Lawyer-led conveyancing and property law for Victorian buyers,
              sellers and investors, based in Carlton, Melbourne.
            </p>
          </div>

          <nav className="md:col-span-3 lg:col-span-3" aria-label="Services" data-id="element-434">
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-cream/45 mb-5" data-id="element-435">
              Services
            </h3>
            <ul className="space-y-3 text-[15px]" data-id="element-436">
              {SERVICE_LINKS.map(link => <li key={link.label} data-id="element-437">
                  <Link to={link.href} className="text-cream/80 hover:text-accent-light transition-colors" data-id="element-438">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="md:col-span-4 lg:col-span-5" data-id="element-439">
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-cream/45 mb-5" data-id="element-440">
              Visit & contact
            </h3>
            <address className="not-italic text-cream/80 space-y-4 text-[15px]" data-id="element-441">
              <p className="flex items-start gap-3" data-id="element-442">
                <MapPin className="w-4 h-4 mt-1 text-accent-light shrink-0" data-id="element-443" />
                <span data-id="element-444">
                  202 Elgin Street
                  <br data-id="element-445" />
                  Carlton VIC 3053, Australia
                </span>
              </p>
              <p className="flex items-center gap-3" data-id="element-446">
                <Phone className="w-4 h-4 text-accent-light shrink-0" data-id="element-447" />
                <a href="tel:+61386172600" className="hover:text-accent-light transition-colors" data-id="element-448">
                  (03) 8617 2600
                </a>
              </p>
              <p className="flex items-center gap-3" data-id="element-449">
                <Mail className="w-4 h-4 text-accent-light shrink-0" data-id="element-450" />
                <a href="mailto:hello@lapropertylaw.com.au" className="hover:text-accent-light transition-colors" data-id="element-451">
                  hello@lapropertylaw.com.au
                </a>
              </p>
              <p className="flex items-start gap-3" data-id="element-452">
                <Clock className="w-4 h-4 mt-1 text-accent-light shrink-0" data-id="element-453" />
                <span data-id="element-454">
                  Mon-Fri 9:00am-5:00pm
                  <br data-id="element-455" />
                  Office visits by appointment only
                </span>
              </p>
              <p className="pt-1" data-id="element-456">
                <a href="https://maps.google.com/?q=202+Elgin+Street,+Carlton+VIC+3053" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-accent-light hover:text-white underline underline-offset-4" data-id="element-457">
                  View on Google Maps
                </a>
              </p>
            </address>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col lg:flex-row justify-between gap-8" data-id="element-458">
          <div className="space-y-2 max-w-3xl text-xs text-cream/45 leading-relaxed" data-id="element-459">
            {/* Footer legal wording needs legal review before launch. */}
            <p data-id="element-460">
              Liability limited by a scheme approved under Professional
              Standards Legislation.
            </p>
            <p data-id="element-461">
              The information on this website is general information and is not
              legal advice. Legal advice should be obtained for your particular
              circumstances.
            </p>
          </div>

          <ul className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-cream/60 shrink-0 h-fit" data-id="element-462">
            {FOOTER_LINKS.map(link => <li key={link.label} data-id="element-463">
                <Link to={link.href} className="hover:text-accent-light transition-colors" data-id="element-464">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>

        <p className="mt-8 text-xs text-cream/35" data-id="element-465">
          &copy; {new Date().getFullYear()} L.A Property Law & Conveyancing.
        </p>
      </div>
    </footer>;
}